module.exports = __webpack_public_path__ + "img/14.2a948789.webp";